export default "__VITE_ASSET__CLw4nJbw__"